/* ==========================================================================
   BentoKids — Collection filter sidebar toggle (mobile)
   Filtering itself is native Shopify (collection.filters -> full page GET
   links), this file only handles showing/hiding the filter panel on
   small screens. No AJAX — keeps behavior simple and safe on a live store.
   ========================================================================== */
(function () {
  function initCollectionFilters(scope) {
    scope = scope || document;
    var toggle = scope.querySelector("#CollectionFilterToggle");
    var panel = scope.querySelector("#CollectionFilters");
    var closeBtn = scope.querySelector("#CollectionFilterClose");
    if (!toggle || !panel || toggle.dataset.bkBound) return;
    toggle.dataset.bkBound = "true";

    function closePanel() {
      panel.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      document.body.classList.remove("bk-no-scroll");
    }

    if (closeBtn) closeBtn.addEventListener("click", closePanel);

    toggle.addEventListener("click", function () {
      var isOpen = panel.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      document.body.classList.toggle("bk-no-scroll", isOpen);
    });

    // Close panel when a filter option is chosen on mobile (link navigates away anyway,
    // but this avoids a flash of open state on back/forward cache restores).
    panel.addEventListener("click", function (e) {
      if (e.target.closest(".collection-filters__option")) {
        panel.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initCollectionFilters(document);
  });
  document.addEventListener("shopify:section:load", function (e) {
    initCollectionFilters(e.target);
  });
})();
